export default "__VITE_ASSET__BemAtYE9__"